import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, ZapIcon } from 'lucide-react';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    label: 'Features',
    href: '#features'
  }, {
    label: 'Roster',
    href: '#roster'
  }, {
    label: 'Brackets',
    href: '#brackets'
  }, {
    label: 'Pricing',
    href: '#pricing'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="fixed top-0 left-0 right-0 z-50 bg-gray-950/80 backdrop-blur-xl border-b border-cyan-500/10" data-id="element-132">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <div className="flex items-center justify-between h-16 lg:h-20" data-id="element-134">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-135">
            <div className="w-8 h-8 bg-gradient-to-br from-cyan-400 to-cyan-600 rounded clip-corner-br flex items-center justify-center" data-id="element-136">
              <ZapIcon className="w-5 h-5 text-gray-950" data-id="element-137" />
            </div>
            <span className="font-display font-bold text-xl tracking-wider" data-id="element-138">
              CLAN<span className="text-cyan-400" data-id="element-139">ARENA</span>
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8" data-id="element-140">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-sm font-medium text-gray-400 hover:text-cyan-400 transition-colors uppercase tracking-wider" data-id="element-141">
                {link.label}
              </a>)}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block" data-id="element-142">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="px-6 py-2.5 bg-cyan-500 text-gray-950 font-bold text-sm uppercase tracking-wider rounded clip-corner-br glow-cyan hover:bg-cyan-400 transition-colors" data-id="element-143">
              Launch HQ
            </motion.button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 text-gray-400 hover:text-cyan-400 transition-colors" aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-144">
            {isMenuOpen ? <XIcon className="w-6 h-6" data-id="element-145" /> : <MenuIcon className="w-6 h-6" data-id="element-146" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-147">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="md:hidden bg-gray-950/95 backdrop-blur-xl border-t border-cyan-500/10" data-id="element-148">
            <div className="px-4 py-6 space-y-4" data-id="element-149">
              {navLinks.map(link => <a key={link.label} href={link.href} onClick={() => setIsMenuOpen(false)} className="block text-lg font-medium text-gray-300 hover:text-cyan-400 transition-colors uppercase tracking-wider" data-id="element-150">
                  {link.label}
                </a>)}
              <button className="w-full mt-4 px-6 py-3 bg-cyan-500 text-gray-950 font-bold text-sm uppercase tracking-wider rounded clip-corner-br" data-id="element-151">
                Launch HQ
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}